import { useEffect } from "react";
import { Button, Group, Box } from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import "dayjs/locale/zh-tw";
import { DatePicker } from "@mantine/dates";
import { showNotification } from "@mantine/notifications";
import { Check } from "tabler-icons-react";

import {
  CityInfoUpdateDate,
  cityInfoUpdateDateSchema,
  useCityInfoUpdateDateQuery,
  useUpdateCityInfoUpdateDateMutation,
  useUpdateLandTradeDataMutation,
} from "services/api";

const Edit = () => {
  const [updateCityUpdateDate] = useUpdateCityInfoUpdateDateMutation();

  const form = useForm<CityInfoUpdateDate>({
    validate: zodResolver(cityInfoUpdateDateSchema),
  });

  const { data: cityUpdateDate } = useCityInfoUpdateDateQuery();

  useEffect(() => {
    if (cityUpdateDate === undefined) {
      return;
    }

    form.setValues({
      cityDataUpdateDt: cityUpdateDate.cityDataUpdateDt,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityUpdateDate]);

  const handleSubmit = async (values: CityInfoUpdateDate) => {
    try {
      await updateCityUpdateDate(values).unwrap();

      showNotification({
        title: "完成",
        message: "城市資訊日期已更新",
        autoClose: 5000,
        color: "cyan",
        icon: <Check />,
      });
    } catch (e) {}
  };

  const [updateLandTradeData, { isLoading }] = useUpdateLandTradeDataMutation();

  const handleClickLandUpdate = async () => {
    await updateLandTradeData().unwrap();
  };

  return (
    <Box py={8} px={36}>
      <h2>城市資訊更新日期</h2>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Group mt="xl" align="end">
          <DatePicker
            placeholder="請選擇日期"
            locale="zh-tw"
            required
            style={{
              flex: "30% 0 0",
            }}
            {...form.getInputProps("cityDataUpdateDt")}
            value={
              form.values.cityDataUpdateDt &&
              new Date(form.values.cityDataUpdateDt)
            }
            withinPortal
          />

          <Button type="submit" color="cyan">
            更新日期
          </Button>
        </Group>
      </form>

      <Box mt={16}>
        <h2>更新不動產交易資訊</h2>
        <Button
          type="button"
          color="cyan"
          loading={isLoading}
          mt={8}
          onClick={handleClickLandUpdate}
        >
          更新交易資訊
        </Button>
      </Box>
    </Box>
  );
};

export default Edit;
